import React from 'react'
import PropTypes from 'prop-types'
import Button from 'components/common/Button/Button'

const AddToQuoteButton = ({ handleClick, disabled, ...props }) =>
  <Button
    data-at-to-quote-button
    { ...props }
    disabled={ disabled }
    narrow
    important
    full="mobile"
    onClick={ handleClick }>Add & Schedule
  </Button>

AddToQuoteButton.propTypes = {
  disabled: PropTypes.bool,
  handleClick: PropTypes.func
}

export default AddToQuoteButton
